import React from 'react';
import { style } from 'typestyle';
import { CarouselIcon } from '../../Icons/LayoutIcons/Carousel';
import { WallIcon } from '../../Icons/LayoutIcons/Wall';
import { MosaicIcon } from '../../Icons/LayoutIcons/Mosaic';
import { QuickSettings } from '../types/QuickSettings';

interface Props {
  layout?: QuickSettings['layout'];
  onChange: (type: QuickSettings['layout']) => any;
}

interface LayoutOptionProps {
  icon: React.ReactNode;
  label: string;
  selected: boolean;
}

const LayoutOption = ({ icon, label }: LayoutOptionProps) => {
  return (
    <div className={optionContainerClass}>
        {icon}
      <div className={labelClass}>
        {label}
      </div>
    </div>
  );
};

export function QuickLayoutSelector({ layout, ...props }: Props) {
  const onChange = (type: QuickSettings['layout']) => {
    props.onChange(type);
  };

  return (
      <div className={selectClass}>
        <LayoutOption 
          icon={<CarouselIcon selected={layout === 'carousel'} onClick={() => onChange('carousel')} />}
          label="Carousel"
          selected={layout === 'carousel'} 
        />
        <LayoutOption 
          icon={<WallIcon selected={layout === 'wall'} onClick={() => onChange('wall')}/>}
          label="Wall"
          selected={layout === 'wall'} 
        />
        <LayoutOption 
          icon={<MosaicIcon selected={layout === 'mosaic'} onClick={() => onChange('mosaic')}/>}
          label="Mosaic"
          selected={layout === 'mosaic'} 
        />
      </div>
  );
}

const selectClass = style({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  width: '100%',
  marginTop: '5px',
  marginBottom: '10px',
});

const optionContainerClass = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  cursor: 'pointer',
  width: '70px',
});

const labelClass = style({
  color: 'white',
  fontSize: '0.7em',
  textAlign: 'center',
  textTransform: 'uppercase',
  marginTop: '5px',
});
